"use strict";

define('rs/models/comment',['rs/models/abstract', 'rs/helper', 'moment'], function (Model, helper, moment) {
  var CommentModel = Model.extend({
    properties: ['activityDate', 'addressed', 'addressedDate', 'addressedPerson', 'addressedPersonId', 'createDate', 'createPerson', 'createPersonId', 'displayAddressedPerson', 'displayCreatePerson', 'displayResolvedPerson', 'documentId', 'finalized', 'finalizedDate', 'hidden', 'id', 'permissions', 'replies', 'resolved', 'resolvedDate', 'resolvedPerson', 'resolvedPersonId', 'text', 'updateUser', 'version'],
    initialize: function initialize() {
      this.listenTo(this, 'change:finalizedDate', this.refreshFinalized);
      this.listenTo(this, 'change:addressedPerson', this.refreshAddressedPerson);
      this.listenTo(this, 'change:createPerson', this.refreshCreatePerson);
      this.listenTo(this, 'change:resolvedPerson', this.refreshResolvedPerson);
      this._super.apply(this, arguments);
      this.date = moment(this.createDate).calendar();
      this.replies = CommentModel.models(this.replies);
      this.listenTo(this, 'change:resolved', this.refreshComplete);
      this.listenTo(this, 'change:addressed', this.refreshComplete);
      this.listenTo(this, 'change:permissions', this.refreshComplete);
      this.refreshComplete();
    },
    setResolvedDate: function setResolvedDate(date) {
      this.set('resolvedDate', date);
      if (date != null) {
        this.setResolved(true);
        this.resolvedDateDisplay = moment(date).calendar();
      } else {
        this.setResolved(false);
        this.resolvedDateDisplay = null;
      }
    },
    refreshComplete: function refreshComplete() {
      var permissions = this.getPermissions() || {};
      if (permissions.canReadComments && this.resolved) {
        this.complete = true;
      } else if (permissions.canAddressComments && this.addressed) {
        this.complete = true;
      } else {
        this.complete = false;
      }
    },
    refreshAddressedPerson: function refreshAddressedPerson() {
      var addressedPerson = this.getAddressedPerson();
      this.setDisplayAddressedPerson(helper.parseServerEnum(addressedPerson));
    },
    refreshCreatePerson: function refreshCreatePerson() {
      var createPerson = this.getCreatePerson();
      this.setDisplayCreatePerson(helper.parseServerEnum(createPerson));
    },
    refreshResolvedPerson: function refreshResolvedPerson() {
      var resolvedPerson = this.getResolvedPerson();
      this.setDisplayResolvedPerson(helper.parseServerEnum(resolvedPerson));
    },
    refreshFinalized: function refreshFinalized() {
      this.setFinalized(this.getFinalizedDate() != null);
    },
    setAddressedDate: function setAddressedDate(date) {
      this.set('addressedDate', date);
      if (date != null) {
        this.setAddressed(true);
        this.addressedDateDisplay = moment(date).calendar();
      } else {
        this.setAddressed(false);
        this.addressedDateDisplay = null;
      }
    },
    requestAddress: function requestAddress(addressed) {
      return this.constructor.requestAddress(this.getId(), addressed).bind(this).tap(this.applyProperties);
    },
    requestResolve: function requestResolve(resolved) {
      return this.constructor.requestResolve(this.getId(), resolved).bind(this).tap(this.applyProperties);
    },
    requestHide: function requestHide() {
      return this.constructor.requestHide(this.getId()).bind(this).tap(this.applyProperties);
    },
    requestUnhide: function requestUnhide() {
      return this.constructor.requestUnhide(this.getId()).bind(this).tap(this.applyProperties);
    },
    requestEdit: function requestEdit(text) {
      return this.constructor.requestEdit(this.getId(), text).bind(this).tap(this.applyProperties);
    },
    requestReply: function requestReply(text) {
      return this.constructor.requestReply(this.getId(), text).bind(this).tap(function (reply) {
        this.getReplies().push(reply);
      });
    },
    requestDelete: function requestDelete() {
      return this.constructor.requestDelete(this.getId());
    }
  }, {
    rootURI: '/rs/api/comment/',
    parsers: {
      'reply/:id': 'model',
      'address/:id/:value': 'model',
      'resolve/:id/:value': 'model',
      'hide/:id': 'model',
      'edit/:id/:value': 'model',
      'comment/:id': 'models'
    },
    requestAddress: function requestAddress(id, addressed) {
      return this.post('address/' + id + '/' + String(!!addressed));
    },
    requestDelete: function requestDelete(id) {
      return this.del(id);
    },
    requestResolve: function requestResolve(id, resolved) {
      return this.post('resolve/' + id + '/' + String(!!resolved));
    },
    requestHide: function requestHide(id) {
      return this.post('hide/' + id, {
        hidden: true
      });
    },
    requestUnhide: function requestUnhide(id) {
      return this.post('hide/' + id, {
        hidden: false
      });
    },
    requestEdit: function requestEdit(id, text) {
      return this.post('edit/' + id, {
        text: text
      });
    },
    requestReply: function requestReply(id, text) {
      return this.post('reply/' + id, {
        text: text
      });
    }
  });
  return CommentModel;
});

